import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { RollOverClient } from "../../parentApi";

const client = new RollOverClient(app_uri, axiosClient());

export default client;
